// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'

const iconStyles = {
  marginTop: '1px',
  paddingLeft: '5px',
}

const Overall = ({ tooltipData }) => {
  const {
    asr,
    structureHeight,
  } = tooltipData

  return (
    <div
      className={'asr-lookup-overall-tooltip display-flex flex-wrap-wrap'}
      id={`asr-lookup-${asr}-overall-tooltip`}>
      <p
        className={'text-blue-dark'}
        style={iconStyles}>
        <i className={'fa fa-plus-circle'} />
      </p>
      <p className={'heading-font padding-left-half'}>
        {'Height w/o Appurtenances'}
      </p>
      <h4
        className={'width-100 center-text text-blue-dark'}
        id={`asr-lookup-${asr}-overall-tooltip-value`}>
        {structureHeight}
      </h4>
    </div>
  )
}

Overall.propTypes = {
  tooltipData: object.isRequired,
}

export default Overall
